module.exports = __webpack_public_path__ + "static/mobile_application_development-f4333de86e6032f31963adc271f44bad.png";